import { GridColumns, GridViews } from '@wcg/frontend-framework';

function _mapGridViewsColumnsWithConfigColumns(
  gColumns: GridColumns,
  configColumns: GridColumns,
  ignoreColMapping = false,
) {
  return Object.entries(configColumns).reduce((acc, [key, value]) => {
    if (ignoreColMapping) {
      acc[key] = {
        ...value,
        selected: true,
      };
    } else {
      acc[key] = {
        ...value,
        selected: false,
      };
      if (gColumns[key]) {
        acc[key] = {
          ...acc[key],
          ordinal: gColumns[key].ordinal,
          selected: gColumns[key].selected ?? true,
          sorted: gColumns[key].sorted,
        };
      }
    }
    return { ...acc };
  }, {} as GridColumns);
}

export function sortColumnsByOrdinal(
  columns: GridColumns,
  initialLoad = false,
) {
  return Object.entries(columns)
    .sort(([, a], [, b]) => {
      const aOrdinal = a.ordinal ?? 0;
      const bOrdinal = b.ordinal ?? 0;

      return aOrdinal - bOrdinal;
    })
    .reduce((acc, [key, value]) => {
      acc[key] = initialLoad ? { ...value, selected: true } : value;
      return acc;
    }, {} as GridColumns);
}

export function extractMatchingGridColumns(
  viewId: string,
  gridViews: GridViews[],
  storeColumns: GridColumns,
) {
  const _view = gridViews.find((v) => v.id === viewId);
  const viewColumns = (_view?.columns ?? {}) as GridColumns;
  const hasColumns = Object.keys(viewColumns).length > 0;
  return !_view || !hasColumns
    ? _mapGridViewsColumnsWithConfigColumns({}, storeColumns, true)
    : _mapGridViewsColumnsWithConfigColumns(viewColumns, storeColumns);
}

export function filterOutActiveColumns(columns: GridColumns) {
  return Object.entries(columns).reduce((acc, [key, value]) => {
    if (value.selected) {
      acc[key] = value;
    }
    return acc;
  }, {} as GridColumns);
}
